exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "section{margin-bottom:3rem}.name,jhi-file-uploader{margin-top:.5rem;margin-bottom:.5rem}.handle{display:flex;align-items:center;justify-content:center}.gu-transit{background-color:#d3d3d3}.input-group{padding-right:.3rem}.input-group-append{align-items:center;padding:0 .7rem;cursor:pointer}.rename-check{display:flex;justify-content:center;align-items:center}.rename-check input{margin-right:1rem}.btn-group div{margin-bottom:.6rem}.btn-group .btn-link{margin-top:1rem}.is-pressed{font-size:1.4em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/requete/add-document/document.component.scss
// module id = 713
// module chunks = 0